module.exports = __webpack_public_path__ + "img/param.0528af5d.svg";